/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StorageBody
 */
export interface StorageBody {
    /**
     * 
     * @type {string}
     * @memberof StorageBody
     */
    value?: string | null;
}

/**
 * Check if a given object implements the StorageBody interface.
 */
export function instanceOfStorageBody(value: object): value is StorageBody {
    return true;
}

export function StorageBodyFromJSON(json: any): StorageBody {
    return StorageBodyFromJSONTyped(json, false);
}

export function StorageBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageBody {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function StorageBodyToJSON(json: any): StorageBody {
    return StorageBodyToJSONTyped(json, false);
}

export function StorageBodyToJSONTyped(value?: StorageBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
    };
}

